import { css } from '@emotion/core';
import { constants, typographyStyles } from '@newsela/angelou';

const { textL, textM, heading5Obj } = typographyStyles;
const { colors } = constants;

export const $standardsContainer = (isReviewingStandards) => {
  return css`
  padding: 12px 32px;
  background-color: ${isReviewingStandards ? '#F0F1F2' : '#E5EFFF'};
  height: ${isReviewingStandards && '-webkit-fill-available'};
  min-height: 100%;

`;
};

export const $noStandardsToReview = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
  max-width: fit-content;
  margin-top: 32px;
  }
  p {
  margin-top: 48px;
  ${heading5Obj};
  }
`;

export const $listingTitle = css`
${textL};
font-weight: 400;
`;
export const $sortOptions = css`
  padding: 16px;
  ${textM};
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 4px;
  left: -9.7rem;
  width: 240px;
  z-index: 1000;
  & > div {
    color:  ${colors.ui.neutral[500]};
    margin: 16px 0;
    cursor: pointer;
  }

  & > div:first-of-type {
    margin-top: 0;
  }

  & > div:last-of-type {
    margin-bottom: 0;
  }
`;

export const $reviewHeaderContainer = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
